import { Space, Typography } from 'antd'
import React from 'react'

interface LimitInfoRowProps {
  title: string
  value: string
}

function LimitInfoRow({ data }: { data: LimitInfoRowProps[] }) {
  return (
    <Space.Compact block direction="vertical">
      {data.map(({ title, value }) => (
        <Space.Compact block style={{ justifyContent: 'space-between' }}>
          <Typography.Text style={{color:"#223142"}}>{title}:</Typography.Text>
          <Typography.Text style={{color:"#223142",fontSize:"14px",fontWeight:700}}>{value}</Typography.Text>
        </Space.Compact>
      ))}
    </Space.Compact>
  )
}

export default LimitInfoRow
